export default "__VITE_ASSET__BycNjoUB__"